import { __makeTemplateObject } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import styled from 'styled-components';
import { Flex, Box } from '@marvelapp/ui';
import Comments from '../containers/Comments';
import ScreenInfo from '../containers/ScreenInfo';
import SidebarHandoffButton from './SidebarHandoffButton';
import SidebarMenu from './SidebarMenu';
import SidebarNavigation from './SidebarNavigation';
export default function Sidebar(_a) {
    var isCommentingEnabled = _a.isCommentingEnabled, isDownloadedProject = _a.isDownloadedProject, isHandoffOpen = _a.isHandoffOpen, isProjectEditButtonVisible = _a.isProjectEditButtonVisible, onShowGrid = _a.onShowGrid, onShowHandoff = _a.onShowHandoff, onShowHome = _a.onShowHome, onShowNext = _a.onShowNext, onShowPrevious = _a.onShowPrevious, projectModified = _a.projectModified, projectName = _a.projectName, projectOwner = _a.projectOwner, projectsByOwnerUrl = _a.projectsByOwnerUrl, projectUrl = _a.projectUrl, screenCount = _a.screenCount, screenName = _a.screenName, screenNumber = _a.screenNumber, screenUrl = _a.screenUrl, showScanQR = _a.showScanQR, userFlowsUrl = _a.userFlowsUrl;
    var showNavigationButtons = screenCount > 1;
    return (React.createElement("div", null,
        !isHandoffOpen && (React.createElement(SidebarWrap, null,
            React.createElement(Flex, null,
                React.createElement(Box, { marginRight: 10 },
                    React.createElement(SidebarMenu, { isProjectEditButtonVisible: isProjectEditButtonVisible, onShowGrid: onShowGrid, onShowHome: onShowHome, projectModified: projectModified, projectName: projectName, projectOwner: projectOwner, projectsByOwnerUrl: projectsByOwnerUrl, projectUrl: projectUrl, screenCount: screenCount, screenName: screenName, screenNumber: screenNumber, screenUrl: screenUrl, showScanQR: showScanQR, userFlowsUrl: userFlowsUrl })),
                !isDownloadedProject && (React.createElement(Box, { marginRight: 10 },
                    React.createElement(SidebarHandoffButton, { onClick: onShowHandoff }))),
                !isDownloadedProject && isCommentingEnabled && (React.createElement(Box, { marginRight: 10 },
                    React.createElement(Comments, null))),
                React.createElement(ScreenInfo, null)))),
        showNavigationButtons && (React.createElement(SidebarNavigation, { isHandoffOpen: isHandoffOpen, onShowNext: onShowNext, onShowPrevious: onShowPrevious }))));
}
var SidebarWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  z-index: 300;\n  bottom: 10px;\n  left: 10px;\n  user-select: none;\n"], ["\n  position: fixed;\n  z-index: 300;\n  bottom: 10px;\n  left: 10px;\n  user-select: none;\n"])));
Sidebar.propTypes = {
    isCommentingEnabled: PropTypes.bool,
    isDownloadedProject: PropTypes.bool,
    isHandoffOpen: PropTypes.bool,
    isProjectEditButtonVisible: PropTypes.bool,
    onShowGrid: PropTypes.func.isRequired,
    onShowHandoff: PropTypes.func.isRequired,
    onShowHome: PropTypes.func,
    onShowNext: PropTypes.func.isRequired,
    onShowPrevious: PropTypes.func.isRequired,
    projectModified: PropTypes.string.isRequired,
    projectName: PropTypes.string.isRequired,
    projectOwner: PropTypes.string.isRequired,
    projectUrl: PropTypes.string.isRequired,
    screenCount: PropTypes.number.isRequired,
    screenName: PropTypes.string,
    screenNumber: PropTypes.number,
    screenUrl: PropTypes.string.isRequired,
    showScanQR: PropTypes.bool.isRequired,
    userFlowsUrl: PropTypes.string.isRequired,
};
Sidebar.defaultProps = {
    isProjectEditButtonVisible: false,
    showGrid: noop,
    showHandoff: noop,
    showHome: noop,
    showNext: noop,
    showPrevious: noop,
};
var templateObject_1;
